class Video {
  constructor() {
    this.videoThumbnails = document.querySelectorAll('.ns-video__thumbnail-container');
    this.videos = document.querySelectorAll('.ns-video__thumbnail');
    this.body = document.querySelector('body');

    if (this.videoThumbnails.length > 0) {
      this.showVideo();
    }

    if(this.body.classList.contains('home')){
      this.videoElement = document.querySelector('.ns-video__video-container video');
      this.videoElement.setAttribute('controls', 'true');
      this.videoElement.setAttribute('allow', 'autoplay');

      this.videoElementThumbnail = document.querySelector('.ns-video__thumbnail');

      this.waitForVideoReady();
    }
  }

  waitForVideoReady() {
    const checkInterval = setInterval(() => {
      if (this.videoElement.readyState >= 3) {
        clearInterval(checkInterval);
      }
    }, 100);

    clearInterval(checkInterval);
    setTimeout(() => {
      this.videoElementThumbnail.style.background = 'none';
    }, 900)
    setTimeout(() => {
      this.videoElement.play();
      this.body.classList.toggle('video--started');
    }, 1000);
  }

  showVideo() {
    this.videoThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {

        setTimeout(() => {
          if (thumbnail) {
            const video = document.querySelector('.ns-video__video-container video');

            if(!this.body.classList.contains('home')){
              thumbnail.classList.add('fade-out');
              thumbnail.style.display = 'none';
              video.play();
            }
          }
        }, 200);
      });
    });
  }
}

export default Video;
